"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class PageInfo {
    constructor({ endCursor, hasNextPage, hasPreviousPage, startCursor, }) {
        this.toJSON = () => ({
            endCursor: this.endCursor,
            hasNextPage: this.hasNextPage,
            hasPreviousPage: this.hasPreviousPage,
            startCursor: this.startCursor,
        });
        this.endCursor = endCursor;
        this.hasNextPage = hasNextPage;
        this.hasPreviousPage = hasPreviousPage;
        this.startCursor = startCursor;
    }
}
PageInfo.fromJSON = (json) => {
    const { endCursor, hasNextPage, hasPreviousPage, startCursor } = Object.assign({}, json);
    if (endCursor !== null && typeof endCursor !== 'string')
        throw new Error('.endCursor must be a string');
    if (typeof hasNextPage !== 'boolean')
        throw new Error('.hasNextPage must be a boolean');
    if (typeof hasPreviousPage !== 'boolean')
        throw new Error('.hasPreviousPage must be a boolean');
    if (startCursor !== null && typeof startCursor !== 'string')
        throw new Error('.startCursor must be a string');
    return new PageInfo({
        endCursor,
        hasNextPage,
        hasPreviousPage,
        startCursor,
    });
};
exports.default = PageInfo;
